import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="bg-cream py-16 md:py-24" aria-labelledby="testimonials-heading" data-id="element-504" data-mp="20qxetgeyquvv">
      <div className="max-w-5xl mx-auto px-4" data-id="element-505" data-mp="1mzisazlukbk2">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-506" data-mp="1r1dwcbv5x31j">
          <p className="font-sans text-terracotta text-xs font-700 tracking-[0.2em] uppercase mb-4" data-id="element-507" data-mp="142r72kmqvmdd">
            Real Women. Real Results.
          </p>
          <h2 id="testimonials-heading" className="font-serif text-forest text-3xl md:text-4xl font-700 leading-tight" data-id="element-508" data-mp="2yeo0uk8nt4bl">
            What Happens When You Stop Fighting Your Biology
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-509" data-mp="2uzrlja0nvroa">
          <motion.article initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-2xl p-7 shadow-sm border border-sage/20 flex flex-col" data-id="element-510" data-mp="2q1ga4uupx93y">
            <div className="flex gap-0.5 mb-4" aria-label="5 out of 5 stars" data-id="element-511" data-mp="2m0mlu0dd5saj">
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-512" data-mp="2lyjlonihyis3" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-513" data-mp="2h0i303ozglh5" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-514" data-mp="19m0vgvqsmnk" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-515" data-mp="3shhwv3qzb8da" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-516" data-mp="3esidut98vlt" />
            </div>
            <blockquote className="font-sans text-stone-700 text-base leading-relaxed italic flex-1 mb-5" data-id="element-517" data-mp="8dvdamfitlg2">
              "I lost 2 inches off my waist in the first 3 weeks — without
              giving up a single meal I loved. I just changed WHEN I ate them."
            </blockquote>
            <footer className="font-sans" data-id="element-518" data-mp="i9oysvb7wp9z">
              <p className="font-700 text-forest text-sm" data-id="element-519" data-mp="3guggfmlh1kb9">Margaret T., 58</p>
              <p className="text-stone-400 text-xs" data-id="element-520" data-mp="3lsi7atp52nxa">Arizona</p>
            </footer>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-2xl p-7 shadow-sm border border-sage/20 flex flex-col" data-id="element-521" data-mp="3qrba9s6suwj7">
            <div className="flex gap-0.5 mb-4" aria-label="5 out of 5 stars" data-id="element-522" data-mp="1k4tb4nffenl4">
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-523" data-mp="1g6c2fzgcx51l" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-524" data-mp="1b569c0isbfrj" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-525" data-mp="168641rtreh1h" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-526" data-mp="1181l7v5dpa83" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-527" data-mp="11a4kz6wc2hq0" />
            </div>
            <blockquote className="font-sans text-stone-700 text-base leading-relaxed italic flex-1 mb-5" data-id="element-528" data-mp="wfguj2hrrd8s">
              "I haven't slept through the night in 4 years. After week 2 of the
              evening protocol, I slept 7 hours straight. The bloating is almost
              gone."
            </blockquote>
            <footer className="font-sans" data-id="element-529" data-mp="dipdkzpp9a7w">
              <p className="font-700 text-forest text-sm" data-id="element-530" data-mp="djqrdby3oatb">Susan K., 63</p>
              <p className="text-stone-400 text-xs" data-id="element-531" data-mp="2dkf6t9yq0uee">Florida</p>
            </footer>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white rounded-2xl p-7 shadow-sm border border-sage/20 flex flex-col" data-id="element-532" data-mp="2ikbaf83iajtf">
            <div className="flex gap-0.5 mb-4" aria-label="5 out of 5 stars" data-id="element-533" data-mp="1kwaz6iwla792">
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-534" data-mp="1kydzbvrghgri" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-535" data-mp="1pvw9tql4g41m" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-536" data-mp="3fbdke4elv366" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-537" data-mp="3k95en52q31dj" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-538" data-mp="3k716gaxsjg7g" />
            </div>
            <blockquote className="font-sans text-stone-700 text-base leading-relaxed italic flex-1 mb-5" data-id="element-539" data-mp="18jpbp9h15k5i">
              "My doctor told me my inflammation markers dropped significantly.
              I told her it was the salmon salad. She didn't believe me until
              she saw the protocol."
            </blockquote>
            <footer className="font-sans" data-id="element-540" data-mp="1rc0b2tch6zyv">
              <p className="font-700 text-forest text-sm" data-id="element-541" data-mp="1raynxqi6qn0s">Linda R., 61</p>
              <p className="text-stone-400 text-xs" data-id="element-542" data-mp="1n9wmr44pk0w6">Ohio</p>
            </footer>
          </motion.article>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center font-sans text-stone-400 text-xs mt-6" data-id="element-543" data-mp="21a7ee9dudjie">
          *Results may vary. Testimonials represent individual experiences.
        </motion.p>
      </div>
    </section>;
}